export const closable = {
  bind(el, binding) {
    const handleOutsideClick = (e) => {
      e.stopPropagation();
      if (!(el === e.target || el.contains(e.target))) {
        binding.value(e, el);
      }
    };
    document.addEventListener('click', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);
  },
  unbind(el, binding) {
    const handleOutsideClick = (e) => {
      e.stopPropagation();
      if (!(el === e.target || el.contains(e.target))) {
        binding.value(e, el);
      }
    };
    document.removeEventListener('click', handleOutsideClick);
    document.removeEventListener('touchstart', handleOutsideClick);
  },
};

export default closable;
